<template>
  <div class="purchase-content">
    <banner url="purchase" hasDivider clazz="purchase-banner">
      <template slot="buttons">
        <el-button class="banner-button" round @click="goRegister('caigou-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="purchase-section1">
      <div class="section1-content">
        <img class="section1-img" src="../../assets/img/purchase/section1.png" alt="通过采购，助力公司战略执行"/>
        <div class="section1-misc">
          <h1 class="misc-title">通过采购，助力公司战略执行</h1>
          <div class="misc-divider"></div>
          <p class="misc-content">
            采购在公司运营中发挥着关键作用。其任务是集中采购以实现节约<br/>
            并加快审批速度，同时还专注于战略，创新和合规等责任。为了提<br/>
            高整个组织的影响力，采购专业人员需要在控制支出和避免风险方<br/>
            面具有战略智慧，同时推动盈利能力和收入增长的全局发展。甄云<br/>
            采购管理系统解决方案使您能够在两者上都表现出色。
          </p>
          <hover-button clazz="consult-button" text="立即咨询" @click.native="goConsult"></hover-button>
        </div>
      </div>
    </div>
    <div class="purchase-section2">
      <div class="section2-content">
        <h1 class="section2-title">您是否遇到过这些问题</h1>
        <div class="section2-divider"></div>
        <ul class="section2-list">
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-1-1@2x.png" alt="供应商开发渠道单一">
            </div>
            <p class="item-misc">供应商开发渠道单一</p>
          </li>
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-1-2@2x.png" alt="采购成本居高不下">
            </div>
            <p class="item-misc">采购成本居高不下<br/>降本增效压力大
            </p>
          </li>
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-2-1@2x.png" alt="供应商管理缺乏根据，效率不高">
            </div>
            <p class="item-misc">供应商管理缺乏根据，效率不高</p>
          </li>
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-2-2@2x.png" alt="采购周期长，成本高">
            </div>
            <p class="item-misc">采购周期长，成本高</p>
          </li>
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-3-1@2x.png" alt="采购团队业务技能欠缺">
            </div>
            <p class="item-misc">采购团队业务技能欠缺</p>
          </li>
          <li class="list-item dib">
            <div class="img-container">
              <img class="image" src="../../assets/img/purchase/section2-3-2@2x.png" alt="行业熟悉度不高，缺乏对市场的了解无法对供应商深度评估">
            </div>
            <p class="item-misc">行业熟悉度不高，缺乏对市场的了解无法对供应商深度评估</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="purchase-section3" @mouseleave="chooseTab('first')">
      <div class="section3-content">
        <h1 class="section3-title">切合采购需求，信息技术优化采购工作</h1>
        <div class="section3-divider"></div>
        <div class="section3-main">
          <div class="section3-choose">
            <div class="left-list">
              <div class="choice" @mouseenter="chooseTab(item.order)"
                   v-for="item in collpaseItem"
                   :class="choice === item.order ? 'is-choosed ' + item.order : item.order">
                <div class="choice-content">
                  <div class="icon-container dib">
                    <img class="icon" v-lazy="item.icon" :alt="item.text">
                  </div>
                  <p class="text">{{item.text}}</p>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="right-content">
              <div :class="item.order + '-content'" v-show="choice === item.order" v-for="item in collpaseItem" :key="item.order">
                <h2 class="title">{{item.subtitle}}</h2>
                <div class="text">
                  <p  v-for="subitem in item.content">{{subitem}}</p>
                </div>
                <img class="image" v-for="subitem2 in item.url" v-lazy="subitem2" :alt="subitem2"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="purchase-section4">
      <div class="section4-content">
        <h1 class="section4-title">采购甄云采购管理系统，您能得到什么？</h1>
        <div class="section4-divider"></div>
        <div class="section4-boxlist">
          <div class="box first">
            <img class="icon" src="../../assets/img/purchase/section4-1@2x.png" alt="控制并降低采购成本"/>
            <h2 class="title">控制并降低采购成本</h2>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">海量货源，及时高效选取供应商，通过集中采购...</p>
              <p class="full-content">海量货源，及时高效选取供应商，通过集中采购，询比价助手，合理控制企业采购成本</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box second">
            <img class="icon" src="../../assets/img/purchase/section4-2@2x.png" alt="保障采购进度按计划进行"/>
            <h2 class="title">保障采购进度按计划进行</h2>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">采购进度能否按计划执行采购进度能否按计划执行采购进...</p>
              <p class="full-content">采购进度能否按计划执行是一项关键因素，甄云采购系统，可实现向供应商催货，
                并提前安排好物流，单证的准备，达到物料的准时交付，从而不影响生产进度</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box third">
            <img class="icon" src="../../assets/img/purchase/section4-3@2x.png" alt="保障产品质量"/>
            <h2 class="title">保障产品质量</h2>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">物料质量控制是基础，甄云系统通过供应商绩效评估报表...</p>
              <p class="full-content">物料质量控制是基础，甄云系统通过供应商绩效评估报表，
                清晰呈现忧虑，促进供应商质量提升</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box fourth">
            <img class="icon" src="../../assets/img/purchase/section4-4@2x.png" alt="简化提升采购效率"/>
            <h2 class="title">简化提升采购效率</h2>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">简化采购工作流程，实现采购全过程的可见性，目录化...</p>
              <p class="full-content">简化采购工作流程，实现采购全过程的可见性，目录化商城快速找到采购商品，提升采购效率</p>
            </div>
            <div class="tail-line">
              <div class="tail"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Purchase',
  metaInfo () {
    return {
      title: this.$seo.purchase.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.purchase.keywords
      },
      {
        name: 'description',
        content: this.$seo.purchase.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      choice: 'first',
      collpaseItem: [
        {
          order: 'first',
          text: '切合采购需求，信息技术优化采购工作',
          subtitle: '丰富的采购资源，助力寻源效率提升',
          url: [
            require('../../assets/img/purchase/2-peitu-1.png')],
          icon: require('../../assets/img/purchase/section3-1@2x.png'),
          content: ['电商资源：平台已对接通用物资电商、MRO物资电商供应商，系统无缝集成',
            '云平台撮合：需求发布云平台，触及平台数万供应商，提升寻源效率',
            '商家后台：支持自有供应商入驻，自定义上架物品，提供比价助手，实现快速择优采购']
        },
        {
          order: 'second',
          text: '高效作业，释放采购劳动力',
          subtitle: '甄云采购系统实现了例行事务自动化，让您有更多时间寻找节省机会',
          url: [
            require('../../assets/img/purchase/2-peitu-2.png')],
          icon: require('../../assets/img/purchase/section3-2@2x.png'),
          content: ['业务超期预警：预制业务预警条件，及时提醒异常情况',
            '自动对账：预制自动对账规则，减少人工核对',
            '发票自动入账：支持与各主流ERP系统集成，借口对接生成应付数据']
        },
        {
          order: 'third',
          text: '采购智能分析与预测，助力采购成本优化',
          subtitle: '智能分析预测，优化采购成本',
          url: [
            require('../../assets/img/purchase/3-peitu-2.png')],
          icon: require('../../assets/img/purchase/section3-3@2x.png'),
          content: ['供应商准入评审：分品类，多策略的准入管控机制',
            '供应商绩效管理：绩效自动计算，绩效结果跟踪',
            '报价模型：可针对不同品类进行报价模型设定，建立多维价格信息库',
            '大宗商品价格预警：基于大宗商品价格变动，及时获取价格变动信息并进行价格调整',
            '报表定制：为企业量身打造数据模型，助力企业采购决策，费用支出分析，价格分析等']
        },
        {
          order: 'fourth',
          text: '打通财务，ERP系统，消息及时送达，提升部门协作',
          subtitle: '甄云采购管理系统，打通财务，ERP等公司内部系统，部门之间消息及时送达，提升部门协作，促进采购效率提升',
          url: [
            require('../../assets/img/purchase/4-peitu-2.png')],
          icon: require('../../assets/img/purchase/section3-4@2x.png'),
          content: []
        }
      ]
    }
  },
  methods: {
    chooseTab (str) {
      this.choice = str
    },
    goRegister (code) {
      this.openRegister(false, code)
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/purchase.scss";
</style>



// WEBPACK FOOTER //
// purchase.vue?2ffac0f2